//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'
import footerNav from '@/components/footerNav'

export default {
  name: "backOrderDetailMore",
    components: {
    footerNav
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toAll(){
      this.$router.push({name:'backOrderDetailAll'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/backOrder/detailMore.vue